import { ActivityDto, InsuranceDto, NoteDto, TaskDto } from '@maia/shared';
import { create } from 'zustand';

type DrawerState =
  | { type: 'note'; data: NoteDto }
  | { type: 'note.add' }
  | { type: 'insurance'; data: InsuranceDto }
  | { type: 'task'; data: TaskDto }
  | { type: 'activity'; data: ActivityDto }
  | null;

export type DrawerStore = {
  state: {
    isOpen: boolean;
    isVisible: boolean;
    info: DrawerState;
  } | null;
  openDrawer: (drawer: Exclude<DrawerState, null>) => void;
  closeDrawer: () => void;
};

export const useDrawerStore = create<DrawerStore>((set) => ({
  state: null,
  openDrawer: (drawer) =>
    set({
      state: {
        isOpen: true,
        isVisible: true,
        info: drawer,
      },
    }),

  closeDrawer: () => {
    set((old) => {
      if (!old.state) return { state: null };

      return {
        state: {
          ...old.state,
          isOpen: false,
        },
      };
    });

    // Use a ref or closure to cancel if needed
    const timeout = setTimeout(() => {
      set(() => ({ state: null }));
    }, 300);

    return () => clearTimeout(timeout); // optional cleanup function
  },
}));
